import {AbstractControl, ValidatorFn} from '@angular/forms';

import {LatinLettersAndSymbolsValidatorKey} from './custom-validator-keys';

export function LatinLettersAndSpecialSymbolsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        const regex = new RegExp(/^[a-zA-Z`~!@#$%^&*()_+\-=\[\]{}\\|;':",.\/<>?]+$/);

        return !regex.test(controlValue) ? {[LatinLettersAndSymbolsValidatorKey]: true} : null;
    };
}
